var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-tracker-summary-item flex flex-col self-start",class:{
    'border-right border-light-gray mr-4': _vm.bar,
    'pr-4': !_vm.loose,
    'pr-8': _vm.loose
  }},[_c('p',{staticClass:"font-size-default min-w-3.5",class:{ 'font-bold': _vm.bold }},[_vm._t("default")],2),_c('p',{staticClass:"text-md text-dark-silver whitespace-no-wrap"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }